import {
  CustomerAccountParams,
  DeleteCustomerAccountData,
  DeleteCustomerAccountError,
  DisableCustomerAccountData,
  DisableCustomerAccountError,
  ApproveCustomerAccountData,
  ApproveCustomerAccountError,
  EnableCustomerAccountData,
  EnableCustomerAccountError,
  GetBookingWindowSettingsData,
  GetPortalBrandData,
  ResetTemplateToDefaultData,
  ResetTemplateToDefaultError,
  GetPortalBrandError,
  PortalBrandUpdate,
  UpdatePortalBrandData,
  UpdatePortalBrandError,
  GetBookingWindowSettingsError,
  GetPortalBookingWindowData,
  GetPortalBookingWindowError,
  UpdateBookingWindowSettingsData,
  UpdateBookingWindowSettingsError,
  BookingWindowSettings,
  ListCustomerAccountsData,
  ListCustomerAccountsError,
  GetCustomerAccountData,
  GetCustomerAccountError,
  ResendCustomerAccountActivationData,
  ResendCustomerAccountActivationError,
  UnlockCustomerAccountData,
  UnlockCustomerAccountError,
} from "./data-contracts";
import {
  AccountActivateData,
  AccountActivateError,
  AccountActivateRequest,
  AccountChangePasswordData,
  AccountChangePasswordError,
  AccountForgotData,
  AccountForgotError,
  AccountForgotRequest,
  AccountLoginData,
  AccountLoginError,
  AccountLoginRequest,
  AccountLogoutData,
  AccountLogoutError,
  AccountPasswordChangeRequest,
  AccountResetData,
  AccountResetError,
  AccountResetRequest,
  AccountStartData,
  AccountStartError,
  AccountStartRequest,
  GetAccountMeData,
  GetAccountMeError,
  GetAccountWorkshopData,
  GetAccountWorkshopError,
  GetAccountWorkshopParams,
} from "./data-contracts";
import {
  ApproveCustomerChangeRequestData,
  ApproveCustomerChangeRequestError,
  ChangeRequestIdParams,
  CountPendingCustomerChangeRequestsData,
  CountPendingCustomerChangeRequestsError,
  CreateChangeRequestData,
  CreateProtocolTicketData,
  CreateProtocolTicketError,
  CreateProtocolTicketParams,
  CreateChangeRequestError,
  GetChangeRequestStatusData,
  GetChangeRequestStatusError,
  ListCustomerChangeRequestsData,
  ListCustomerChangeRequestsError,
  ListCustomerChangeRequestsParams,
  ListProtocolsData,
  ListProtocolsError,
  PortalProtocolsRequest,
  PortalChangeRequestAccess,
  PortalChangeRequestCreate,
  RejectCustomerChangeRequestBody,
  RejectCustomerChangeRequestData,
  RejectCustomerChangeRequestError,
  WithdrawChangeRequestData,
  WithdrawChangeRequestError,
} from "./data-contracts";
import {
  AdminTokenListItem,
  AuditLogEntry,
  BackupCodesResponse,
  DeleteAllPricesResponse,
  GettyGoSyncAllResponse,
  HTTPValidationError,
  SessionListItem,
  StorageLocationResponse,
  StorageLocationUpdate,
  TOTPSetupResponse,
  TOTPStatusResponse,
  TyreSystemSyncResponse,
  AuditLogStats,
  BatchEmailRequest,
  BatchEmailResponse,
  ContinueUseData,
  ContinueUseError,
  ContinueUseRequest,
  CreateCustomerData,
  CreateCustomerError,
  CreateCustomerRequest,
  CreateOrderData,
  CreateOrderError,
  CreateOrderRequest,
  CreateTemplateData,
  CreateTemplateError,
  CreateTirePriceData,
  CreateTirePriceError,
  CreateVehicleData,
  CreateVehicleError,
  DeleteCustomerData,
  DeleteCustomerError,
  DeleteCustomerParams,
  DeleteOrderData,
  DeleteOrderError,
  DeleteOrderParams,
  DeleteTemplateData,
  DeleteTemplateError,
  DeleteTemplateParams,
  DeleteTirePriceData,
  DeleteTirePriceError,
  DeleteTirePriceParams,
  DeleteVehicleData,
  DeleteVehicleError,
  DeleteVehicleParams,
  EmailAnalyticsOverall,
  EmailAnalyticsTemplate,
  EmailAttachment,
  ErrorLogEntry,
  ErrorLogStats,
  BatchResolveRequest,
  CleanupResolvedResponse,
  BatchRevokeTokensRequest,
  CleanupRevokedTokensResponse,
  EmailSettingsUpdateRequest,
  EmailTemplateCreate,
  EmailTemplateUpdate,
  ListAttachmentsParams,
  UploadAttachmentResponse,
  GetCurrentUserInfoData,
  GetCustomerData,
  GetAuditStatsParams,
  GetCustomerError,
  GetCustomerParams,
  GetCustomerTirePricesData,
  GetCustomerTirePricesError,
  GetCustomerTirePricesParams,
  GetTireOfferPdfData,
  GetTireOfferPdfError,
  GetTireOfferPdfParams,
  DeleteTireOfferData,
  DeleteTireOfferError,
  DeleteTireOfferParams,
  GetDashboardStatsData,
  GetEmailSettingsData,
  GetErrorStatsParams,
  GetPortalTextsAdminData,
  GetPortalTextsAdminError,
  GetPortalTextsData,
  GetPortalTextsError,
  GetPublicSettingsData,
  GetSettingsData,
  GetTyresystemOrderInterfaceStatusData,
  GetTyresystemOrderSettingsData,
  ListAuditLogsParams,
  ListCustomersData,
  ListCustomersError,
  ListCustomersParams,
  ListErrorLogsParams,
  ListOffersData,
  ListOffersError,
  ListOffersParams,
  ListOrdersData,
  ListOrdersError,
  ListOrdersParams,
  ListTemplatesData,
  ListTemplatesError,
  ListTemplatesParams,
  ListTireOffersData,
  ListTireOffersError,
  ListTireOffersParams,
  ListTirePricesData,
  ListTirePricesError,
  ListTirePricesParams,
  ListVehiclesData,
  ListVehiclesError,
  ListVehiclesParams,
  MyOrdersData,
  MyOrdersError,
  MyOrdersParams,
  OrderSettingsUpdateRequest,
  PortalResolveRequest,
  PortalTextsUpdateRequest,
  PreviewTemplateData,
  ReorderOrderData,
  ReorderOrderError,
  ResolveErrorRequest,
  PreviewTemplateError,
  PreviewTemplateParams,
  ResolvePortalData,
  ResolvePortalError,
  SendEmailRequest,
  SendEmailResponse,
  SendTestEmailData,
  SendTestEmailError,
  SettingsUpdateRequest,
  TestEmailRequest,
  TirePriceCreate,
  TirePriceUpdate,
  DemoTire,
  DemoTireCreate,
  DemoTireUpdate,
  ListDemoTiresData,
  ListDemoTiresError,
  ListDemoTiresParams,
  ListDemoTireBrandsData,
  GetDemoTireAvailabilityData,
  GetDemoTireAvailabilityError,
  DeleteDemoTireData,
  DeleteDemoTireError,
  TireSetUpdate,
  UpdateCustomerData,
  UpdateCustomerError,
  UpdateCustomerParams,
  UpdateCustomerRequest,
  UpdateEmailSettingsData,
  UpdateEmailSettingsError,
  UpdateOrderRequest,
  UpdateOrderStatusData,
  UpdateOrderStatusError,
  UpdateOrderStatusParams,
  UpdatePortalTextsAdminData,
  UpdatePortalTextsAdminError,
  UpdateSettingsData,
  UpdateSettingsError,
  UpdateTemplateData,
  UpdateTemplateError,
  UpdateTemplateParams,
  UpdateTirePriceData,
  UpdateTirePriceError,
  UpdateTirePriceParams,
  UpdateTireSetData,
  UpdateTireSetError,
  UpdateTireSetParams,
  UpdateTyresystemOrderSettingsData,
  UpdateTyresystemOrderSettingsError,
  UpdateVehicleData,
  UpdateVehicleError,
  UpdateVehicleParams,
  VehicleCreate,
  VehicleUpdate,
  ListTireSetsParams,
  ListTireSetsData,
  ListTireSetsError,
  SearchTireChangeByLicenseData,
  SearchTireChangeByLicenseError,
  GetPreparationPdfData,
  GetPreparationPdfError,
  GetTireLabelsPdfData,
  GetTireLabelsPdfError,
  SendRetrievalEmailRequest,
  ReStoreRequest,
  GetStorageLocationsData,
  GetStorageLocationsError,
  ManualOrderRequest,
  CreateManualOrderData,
  CreateManualOrderError,
  OfferPdfRequest,
  CreateOfferPdfData,
  CreateOfferPdfError,
  OfferPdfEmailRequest,
  SendOfferPdfEmailData,
  SendOfferPdfEmailError,
  EmployeeCreateRequest,
  CompleteSwapRequest,
  ListEmployeesData,
  CreateEmployeeData,
  CreateEmployeeError,
  DeleteEmployeeData,
  DeleteEmployeeError,
  CompleteSwapData,
  CompleteSwapError,
  GetPrintQueueData,
  MarkPrintedData,
  MarkPrintedError,
  DownloadSwapReceiptData,
  DownloadSwapReceiptError,
  GetSeasonChangeStatusData,
  StartSeasonOnboardingData,
  ConfirmSeasonChangeStepRequest,
  ConfirmSeasonChangeStepData,
  ConfirmSeasonChangeStepError,
  UnconfirmSeasonChangeStepData,
  UnconfirmSeasonChangeStepError,
  ReleaseSeasonChangeData,
  ArchiveOrdersRequest,
  ArchiveOrdersData,
  ArchiveOrdersError,
  UnarchiveOrdersData,
  UnarchiveOrdersError,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Brain<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * @description Get dashboard statistics
   *
   * @tags dbtn/module:stats, dbtn/hasAuth
   * @name get_dashboard_stats
   * @summary Get Dashboard Stats
   * @request GET:/routes/stats/
   */
  get_dashboard_stats = (params: RequestParams = {}) =>
    this.request<GetDashboardStatsData, HTTPValidationError>({
      path: `/routes/stats/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get the current season-change onboarding status for the tenant.
   *
   * @tags dbtn/module:season_change_status, dbtn/hasAuth
   * @name get_season_change_status
   * @summary Get Season Change Status
   * @request GET:/routes/season-change-status/
   */
  get_season_change_status = (params: RequestParams = {}) =>
    this.request<GetSeasonChangeStatusData, HTTPValidationError>({
      path: `/routes/season-change-status/`,
      method: "GET",
      ...params,
    });

  /**
   * @description Close out the current season change and start onboarding into the next season. Admin only.
   *
   * @tags dbtn/module:season_change_status, dbtn/hasAuth
   * @name start_season_onboarding
   * @summary Start Season Onboarding
   * @request POST:/routes/season-change-status/start-onboarding
   */
  start_season_onboarding = (params: RequestParams = {}) =>
    this.request<StartSeasonOnboardingData, HTTPValidationError>({
      path: `/routes/season-change-status/start-onboarding`,
      method: "POST",
      ...params,
    });

  /**
   * @description Manually confirm/override an onboarding step. Admin only.
   *
   * @tags dbtn/module:season_change_status, dbtn/hasAuth
   * @name confirm_season_change_step
   * @summary Confirm Season Change Step
   * @request POST:/routes/season-change-status/confirm-step
   */
  confirm_season_change_step = (data: ConfirmSeasonChangeStepRequest, params: RequestParams = {}) =>
    this.request<ConfirmSeasonChangeStepData, ConfirmSeasonChangeStepError>({
      path: `/routes/season-change-status/confirm-step`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Undo a manual step confirmation. Admin only.
   *
   * @tags dbtn/module:season_change_status, dbtn/hasAuth
   * @name unconfirm_season_change_step
   * @summary Unconfirm Season Change Step
   * @request POST:/routes/season-change-status/unconfirm-step
   */
  unconfirm_season_change_step = (data: ConfirmSeasonChangeStepRequest, params: RequestParams = {}) =>
    this.request<UnconfirmSeasonChangeStepData, UnconfirmSeasonChangeStepError>({
      path: `/routes/season-change-status/unconfirm-step`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Release the new season, ending onboarding mode. Admin only.
   *
   * @tags dbtn/module:season_change_status, dbtn/hasAuth
   * @name release_season_change
   * @summary Release Season Change
   * @request POST:/routes/season-change-status/release
   */
  release_season_change = (params: RequestParams = {}) =>
    this.request<ReleaseSeasonChangeData, HTTPValidationError>({
      path: `/routes/season-change-status/release`,
      method: "POST",
      ...params,
    });

  /**
   * @description List customers with tire status summary
   *
   * @tags dbtn/module:customers, dbtn/hasAuth
   * @name list_customers
   * @summary List Customers
   * @request GET:/routes/customers/
   */
  list_customers = (query: ListCustomersParams, params: RequestParams = {}) =>
    this.request<ListCustomersData, ListCustomersError>({
      path: `/routes/customers/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Create a new customer
   *
   * @tags dbtn/module:customers, dbtn/hasAuth
   * @name create_customer
   * @summary Create Customer
   * @request POST:/routes/customers/
   */
  create_customer = (data: CreateCustomerRequest, params: RequestParams = {}) =>
    this.request<CreateCustomerData, CreateCustomerError>({
      path: `/routes/customers/`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get customer with full tire set details
   *
   * @tags dbtn/module:customers, dbtn/hasAuth
   * @name get_customer
   * @summary Get Customer
   * @request GET:/routes/customers/{customer_id}
   */
  get_customer = ({ customerId }: GetCustomerParams, params: RequestParams = {}) =>
    this.request<GetCustomerData, GetCustomerError>({
      path: `/routes/customers/${customerId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update an existing customer
   *
   * @tags dbtn/module:customers, dbtn/hasAuth
   * @name update_customer
   * @summary Update Customer
   * @request PUT:/routes/customers/{customer_id}
   */
  update_customer = (
    { customerId }: UpdateCustomerParams,
    data: UpdateCustomerRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateCustomerData, UpdateCustomerError>({
      path: `/routes/customers/${customerId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete a customer and their tire sets (CASCADE)
   *
   * @tags dbtn/module:customers, dbtn/hasAuth
   * @name delete_customer
   * @summary Delete Customer
   * @request DELETE:/routes/customers/{customer_id}
   */
  delete_customer = ({ customerId }: DeleteCustomerParams, params: RequestParams = {}) =>
    this.request<DeleteCustomerData, DeleteCustomerError>({
      path: `/routes/customers/${customerId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });

  /**
   * @description Get current user information and permissions
   *
   * @tags dbtn/module:users, dbtn/hasAuth
   * @name get_current_user_info
   * @summary Get Current User Info
   * @request GET:/routes/users/me
   */
  get_current_user_info = (params: RequestParams = {}) =>
    this.request<GetCurrentUserInfoData, HTTPValidationError>({
      path: `/routes/users/me`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:vehicles, dbtn/hasAuth
   * @name list_vehicles
   * @summary List Vehicles
   * @request GET:/routes/vehicles
   */
  list_vehicles = (query: ListVehiclesParams, params: RequestParams = {}) =>
    this.request<ListVehiclesData, ListVehiclesError>({
      path: `/routes/vehicles`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:vehicles, dbtn/hasAuth
   * @name create_vehicle
   * @summary Create Vehicle
   * @request POST:/routes/vehicles
   */
  create_vehicle = (data: VehicleCreate, params: RequestParams = {}) =>
    this.request<CreateVehicleData, CreateVehicleError>({
      path: `/routes/vehicles`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:vehicles, dbtn/hasAuth
   * @name update_vehicle
   * @summary Update Vehicle
   * @request PUT:/routes/vehicles/{vehicle_id}
   */
  update_vehicle = ({ vehicleId }: UpdateVehicleParams, data: VehicleUpdate, params: RequestParams = {}) =>
    this.request<UpdateVehicleData, UpdateVehicleError>({
      path: `/routes/vehicles/${vehicleId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:vehicles, dbtn/hasAuth
   * @name delete_vehicle
   * @summary Delete Vehicle
   * @request DELETE:/routes/vehicles/{vehicle_id}
   */
  delete_vehicle = ({ vehicleId }: DeleteVehicleParams, params: RequestParams = {}) =>
    this.request<DeleteVehicleData, DeleteVehicleError>({
      path: `/routes/vehicles/${vehicleId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get distinct tire brands for this tenant
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name list_price_brands
   * @summary List Price Brands
   * @request GET:/routes/prices/brands
   */
  list_price_brands = (query: { active_only?: boolean } = {}, params: RequestParams = {}) =>
    this.request<string[], HTTPValidationError>({
      path: `/routes/prices/brands`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List tire prices (admin only)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name list_tire_prices
   * @summary List Tire Prices
   * @request GET:/routes/prices
   */
  list_tire_prices = (query: ListTirePricesParams, params: RequestParams = {}) =>
    this.request<ListTirePricesData, ListTirePricesError>({
      path: `/routes/prices`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a single tire price (prices:view permission)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name get_tire_price
   * @summary Get Tire Price
   * @request GET:/routes/prices/{price_id}
   */
  get_tire_price = ({ priceId }: { priceId: number }, params: RequestParams = {}) =>
    this.request<import("./data-contracts").TirePrice, HTTPValidationError>({
      path: `/routes/prices/${priceId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Create a new tire price (admin only)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name create_tire_price
   * @summary Create Tire Price
   * @request POST:/routes/prices
   */
  create_tire_price = (data: TirePriceCreate, params: RequestParams = {}) =>
    this.request<CreateTirePriceData, CreateTirePriceError>({
      path: `/routes/prices`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Update tire price (admin only)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name update_tire_price
   * @summary Update Tire Price
   * @request PUT:/routes/prices/{price_id}
   */
  update_tire_price = (
    { priceId }: UpdateTirePriceParams,
    data: TirePriceUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateTirePriceData, UpdateTirePriceError>({
      path: `/routes/prices/${priceId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete tire price (admin only)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name delete_tire_price
   * @summary Delete Tire Price
   * @request DELETE:/routes/prices/{price_id}
   */
  delete_tire_price = ({ priceId }: DeleteTirePriceParams, params: RequestParams = {}) =>
    this.request<DeleteTirePriceData, DeleteTirePriceError>({
      path: `/routes/prices/${priceId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Demo-Reifen auflisten (gebrauchte Vorführreifen, manuell gepflegt)
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name list_demo_tires
   * @summary List Demo Tires
   * @request GET:/routes/demo-tires
   */
  list_demo_tires = (query: ListDemoTiresParams, params: RequestParams = {}) =>
    this.request<ListDemoTiresData, ListDemoTiresError>({
      path: `/routes/demo-tires`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Marken der Demo-Reifen für den Filter
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name list_demo_tire_brands
   * @summary List Demo Tire Brands
   * @request GET:/routes/demo-tires/brands
   */
  list_demo_tire_brands = (query: { active_only?: boolean }, params: RequestParams = {}) =>
    this.request<ListDemoTireBrandsData, HTTPValidationError>({
      path: `/routes/demo-tires/brands`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Demo-Bestand je Reifengröße für den Hinweis-Badge. Größen ohne Bestand fehlen im Ergebnis.
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name get_demo_tire_availability
   * @summary Get Demo Tire Availability
   * @request GET:/routes/demo-tires/availability
   */
  get_demo_tire_availability = (query: { sizes: string }, params: RequestParams = {}) =>
    this.request<GetDemoTireAvailabilityData, GetDemoTireAvailabilityError>({
      path: `/routes/demo-tires/availability`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Einzelnen Demo-Reifen abrufen
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name get_demo_tire
   * @summary Get Demo Tire
   * @request GET:/routes/demo-tires/{demo_tire_id}
   */
  get_demo_tire = ({ demoTireId }: { demoTireId: number }, params: RequestParams = {}) =>
    this.request<DemoTire, HTTPValidationError>({
      path: `/routes/demo-tires/${demoTireId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Demo-Reifen anlegen
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name create_demo_tire
   * @summary Create Demo Tire
   * @request POST:/routes/demo-tires
   */
  create_demo_tire = (data: DemoTireCreate, params: RequestParams = {}) =>
    this.request<DemoTire, HTTPValidationError>({
      path: `/routes/demo-tires`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Demo-Reifen ändern (inkl. Bestandskorrektur)
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name update_demo_tire
   * @summary Update Demo Tire
   * @request PUT:/routes/demo-tires/{demo_tire_id}
   */
  update_demo_tire = (
    { demoTireId }: { demoTireId: number },
    data: DemoTireUpdate,
    params: RequestParams = {},
  ) =>
    this.request<DemoTire, HTTPValidationError>({
      path: `/routes/demo-tires/${demoTireId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Demo-Reifen löschen
   *
   * @tags dbtn/module:demo_tires, dbtn/hasAuth
   * @name delete_demo_tire
   * @summary Delete Demo Tire
   * @request DELETE:/routes/demo-tires/{demo_tire_id}
   */
  delete_demo_tire = ({ demoTireId }: { demoTireId: number }, params: RequestParams = {}) =>
    this.request<DeleteDemoTireData, DeleteDemoTireError>({
      path: `/routes/demo-tires/${demoTireId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * Delete all tire prices for testing
   *
   * @request DELETE:/routes/prices/all
   */
  deleteAllTirePrices = (params: RequestParams = {}) =>
    this.request<DeleteAllPricesResponse, HTTPValidationError>({
      path: `/routes/prices/all`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get relevant tire prices for customer's tires
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name get_customer_tire_prices
   * @summary Get Customer Tire Prices
   * @request GET:/routes/prices/for-customer/{customer_id}
   */
  get_customer_tire_prices = ({ customerId }: GetCustomerTirePricesParams, params: RequestParams = {}) =>
    this.request<GetCustomerTirePricesData, GetCustomerTirePricesError>({
      path: `/routes/prices/for-customer/${customerId}`,
      method: "GET",
      ...params,
    });

  /**
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name get_offer_settings
   * @summary Get Offer Settings (service prices for offer dialog, prices:view permission)
   * @request GET:/routes/prices/offer-settings
   */
  get_offer_settings = (params: RequestParams = {}) =>
    this.request<{ service_price_mounting_up_to_17: number; service_price_mounting_18_plus: number; service_price_change: number; service_price_storage: number }, HTTPValidationError>({
      path: `/routes/prices/offer-settings`,
      method: "GET",
      ...params,
    });

  quick_order_notify = (data: {
    tire_price_id: number;
    quantity: number;
    include_change: boolean;
    include_storage: boolean;
    customer_name: string;
    license_plate: string;
    comment?: string;
    price_override?: number;
    offer_id?: number;
  }, params: RequestParams = {}) =>
    this.request<{ success: boolean }, HTTPValidationError>({
      path: `/routes/prices/quick-order-notify`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Generate a downloadable PDF price offer for a tire and save it to the Angebotshistory
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name create_offer_pdf
   * @summary Create Offer PDF
   * @request POST:/routes/prices/offer-pdf
   */
  create_offer_pdf = (data: OfferPdfRequest, params: RequestParams = {}) =>
    this.request<CreateOfferPdfData, CreateOfferPdfError>({
      path: `/routes/prices/offer-pdf`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "blob",
      ...params,
    });

  /**
   * @description Generate the offer PDF, save it to the Angebotshistory and e-mail it to the customer as an attachment
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name send_offer_pdf_email
   * @summary Send Offer Pdf Email
   * @request POST:/routes/prices/offer-pdf/email
   */
  send_offer_pdf_email = (data: OfferPdfEmailRequest, params: RequestParams = {}) =>
    this.request<SendOfferPdfEmailData, SendOfferPdfEmailError>({
      path: `/routes/prices/offer-pdf/email`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description List saved tire offers (Angebotshistory), tenant-scoped
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name list_tire_offers
   * @summary List Tire Offers
   * @request GET:/routes/prices/offers
   */
  list_tire_offers = (query: ListTireOffersParams, params: RequestParams = {}) =>
    this.request<ListTireOffersData, ListTireOffersError>({
      path: `/routes/prices/offers`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Re-download a previously saved offer PDF from the Angebotshistory
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name get_tire_offer_pdf
   * @summary Get Tire Offer PDF
   * @request GET:/routes/prices/offers/{offer_id}/pdf
   */
  get_tire_offer_pdf = ({ offerId }: GetTireOfferPdfParams, params: RequestParams = {}) =>
    this.request<GetTireOfferPdfData, GetTireOfferPdfError>({
      path: `/routes/prices/offers/${offerId}/pdf`,
      method: "GET",
      format: "blob",
      ...params,
    });

  /**
   * @description Delete a saved offer from the Angebotshistory (tenant-admin only)
   *
   * @tags dbtn/module:prices, dbtn/hasAuth
   * @name delete_tire_offer
   * @summary Delete Tire Offer
   * @request DELETE:/routes/prices/offers/{offer_id}
   */
  delete_tire_offer = ({ offerId }: DeleteTireOfferParams, params: RequestParams = {}) =>
    this.request<DeleteTireOfferData, DeleteTireOfferError>({
      path: `/routes/prices/offers/${offerId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get current settings (admin only)
   *
   * @tags dbtn/module:settings, dbtn/hasAuth
   * @name get_settings
   * @summary Get Settings
   * @request GET:/routes/settings
   */
  get_settings = (params: RequestParams = {}) =>
    this.request<GetSettingsData, HTTPValidationError>({
      path: `/routes/settings`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update settings (admin only)
   *
   * @tags dbtn/module:settings, dbtn/hasAuth
   * @name update_settings
   * @summary Update Settings
   * @request PUT:/routes/settings
   */
  update_settings = (data: SettingsUpdateRequest, params: RequestParams = {}) =>
    this.request<UpdateSettingsData, UpdateSettingsError>({
      path: `/routes/settings`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name get_email_settings
   * @summary Get Email Settings
   * @request GET:/routes/email/settings
   */
  get_email_settings = (params: RequestParams = {}) =>
    this.request<GetEmailSettingsData, HTTPValidationError>({
      path: `/routes/email/settings`,
      method: "GET",
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name update_email_settings
   * @summary Update Email Settings
   * @request PUT:/routes/email/settings
   */
  update_email_settings = (data: EmailSettingsUpdateRequest, params: RequestParams = {}) =>
    this.request<UpdateEmailSettingsData, UpdateEmailSettingsError>({
      path: `/routes/email/settings`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name send_test_email
   * @summary Send Test Email
   * @request POST:/routes/email/settings/test
   */
  send_test_email = (data: TestEmailRequest, params: RequestParams = {}) =>
    this.request<SendTestEmailData, SendTestEmailError>({
      path: `/routes/email/settings/test`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name list_templates
   * @summary List Templates
   * @request GET:/routes/email/templates
   */
  list_templates = (query: ListTemplatesParams, params: RequestParams = {}) =>
    this.request<ListTemplatesData, ListTemplatesError>({
      path: `/routes/email/templates`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name create_template
   * @summary Create Template
   * @request POST:/routes/email/templates
   */
  create_template = (data: EmailTemplateCreate, params: RequestParams = {}) =>
    this.request<CreateTemplateData, CreateTemplateError>({
      path: `/routes/email/templates`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name update_template
   * @summary Update Template
   * @request PUT:/routes/email/templates/{templateId}
   */
  update_template = (
    { templateId }: UpdateTemplateParams,
    data: EmailTemplateUpdate,
    params: RequestParams = {},
  ) =>
    this.request<UpdateTemplateData, UpdateTemplateError>({
      path: `/routes/email/templates/${templateId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name delete_template
   * @summary Delete Template
   * @request DELETE:/routes/email/templates/{templateId}
   */
  delete_template = ({ templateId }: DeleteTemplateParams, params: RequestParams = {}) =>
    this.request<DeleteTemplateData, DeleteTemplateError>({
      path: `/routes/email/templates/${templateId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Betreff und Text einer Vorlage auf den Standard (neues Design) zurücksetzen
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name reset_template_to_default
   * @request POST:/routes/email/templates/{templateId}/reset-default
   */
  reset_template_to_default = ({ templateId }: DeleteTemplateParams, params: RequestParams = {}) =>
    this.request<ResetTemplateToDefaultData, ResetTemplateToDefaultError>({
      path: `/routes/email/templates/${templateId}/reset-default`,
      method: "POST",
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name preview_template
   * @summary Preview Template
   * @request POST:/routes/email/templates/{templateId}/preview
   */
  preview_template = ({ templateId }: PreviewTemplateParams, params: RequestParams = {}) =>
    this.request<PreviewTemplateData, PreviewTemplateError>({
      path: `/routes/email/templates/${templateId}/preview`,
      method: "POST",
      ...params,
    });

  /**
   * @description Send an email to a customer using a template. Optionally generates portal link.
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name send_customer_email
   * @summary Send Customer Email
   * @request POST:/routes/email/send
   */
  send_customer_email = (data: SendEmailRequest, params: RequestParams = {}) =>
    this.request<SendEmailResponse, HTTPValidationError>({
      path: `/routes/email/send`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Upload email attachment
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name upload_attachment
   * @summary Upload Attachment
   * @request POST:/routes/email/attachments/upload
   */
  upload_attachment = (data: FormData, params: RequestParams = {}) =>
    this.request<UploadAttachmentResponse, HTTPValidationError>({
      path: `/routes/email/attachments/upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description Upload an image for use in email templates
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name upload_template_image
   * @summary Upload Template Image
   * @request POST:/routes/email/template-images/upload
   */
  upload_template_image = (data: FormData, params: RequestParams = {}) =>
    this.request<{ url: string; filename: string }, HTTPValidationError>({
      path: `/routes/email/template-images/upload`,
      method: "POST",
      body: data,
      type: ContentType.FormData,
      ...params,
    });

  /**
   * @description List email attachments
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name list_attachments
   * @summary List Attachments
   * @request GET:/routes/email/attachments
   */
  list_attachments = (query: ListAttachmentsParams, params: RequestParams = {}) =>
    this.request<EmailAttachment[], HTTPValidationError>({
      path: `/routes/email/attachments`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Download email attachment
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name download_attachment
   * @summary Download Attachment
   * @request GET:/routes/email/attachments/{attachment_id}
   */
  download_attachment = (attachmentId: number, params: RequestParams = {}) =>
    this.request<Blob, HTTPValidationError>({
      path: `/routes/email/attachments/${attachmentId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Delete email attachment
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name delete_attachment
   * @summary Delete Attachment
   * @request DELETE:/routes/email/attachments/{attachment_id}
   */
  delete_attachment = (attachmentId: number, params: RequestParams = {}) =>
    this.request<{ status: string; message: string }, HTTPValidationError>({
      path: `/routes/email/attachments/${attachmentId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Send batch email to multiple customers
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name send_batch_email
   * @summary Send Batch Email
   * @request POST:/routes/email/send-batch
   */
  send_batch_email = (data: BatchEmailRequest, params: RequestParams = {}) =>
    this.request<BatchEmailResponse, HTTPValidationError>({
      path: `/routes/email/send-batch`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get overall email analytics
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name get_email_analytics_overall
   * @summary Get Email Analytics Overall
   * @request GET:/routes/email/analytics/overall
   */
  get_email_analytics_overall = (params: RequestParams = {}) =>
    this.request<EmailAnalyticsOverall, HTTPValidationError>({
      path: `/routes/email/analytics/overall`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get email analytics for specific template
   *
   * @tags dbtn/module:mailer, dbtn/hasAuth
   * @name get_email_analytics_template
   * @summary Get Email Analytics Template
   * @request GET:/routes/email/analytics/template/{template_key}
   */
  get_email_analytics_template = (templateKey: string, params: RequestParams = {}) =>
    this.request<EmailAnalyticsTemplate, HTTPValidationError>({
      path: `/routes/email/analytics/template/${templateKey}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update tire set and handle mounted uniqueness server-side
   *
   * @tags dbtn/module:tire_sets, dbtn/hasAuth
   * @name update_tire_set
   * @summary Update Tire Set
   * @request PUT:/routes/tire-sets/{tire_set_id}
   */
  update_tire_set = ({ tireSetId }: UpdateTireSetParams, data: TireSetUpdate, params: RequestParams = {}) =>
    this.request<UpdateTireSetData, UpdateTireSetError>({
      path: `/routes/tire-sets/${tireSetId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  delete_tire_set = ({ tireSetId }: { tireSetId: number }, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/routes/tire-sets/${tireSetId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name list_orders
   * @summary List Orders
   * @request GET:/routes/orders/
   */
  list_orders = (query: ListOrdersParams, params: RequestParams = {}) =>
    this.request<ListOrdersData, ListOrdersError>({
      path: `/routes/orders/`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get a single order (tenant-scoped, orders:view permission)
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name get_order
   * @summary Get Order
   * @request GET:/routes/orders/{order_id}
   */
  get_order = ({ orderId }: { orderId: number }, params: RequestParams = {}) =>
    this.request<import("./data-contracts").OrderListItem, HTTPValidationError>({
      path: `/routes/orders/${orderId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Archive a set of orders (tenant-scoped). Hides them from the default list.
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name archive_orders
   * @summary Archive Orders
   * @request POST:/routes/orders/archive
   */
  archive_orders = (data: ArchiveOrdersRequest, params: RequestParams = {}) =>
    this.request<ArchiveOrdersData, ArchiveOrdersError>({
      path: `/routes/orders/archive`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Restore a set of archived orders back into the default list (tenant-scoped).
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name unarchive_orders
   * @summary Unarchive Orders
   * @request POST:/routes/orders/unarchive
   */
  unarchive_orders = (data: ArchiveOrdersRequest, params: RequestParams = {}) =>
    this.request<UnarchiveOrdersData, UnarchiveOrdersError>({
      path: `/routes/orders/unarchive`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name update_order_status
   * @summary Update Order Status
   * @request PUT:/routes/orders/{order_id}
   */
  update_order_status = (
    { orderId }: UpdateOrderStatusParams,
    data: UpdateOrderRequest,
    params: RequestParams = {},
  ) =>
    this.request<UpdateOrderStatusData, UpdateOrderStatusError>({
      path: `/routes/orders/${orderId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name update_order_part_number
   * @summary Update Order Part Number
   * @request PATCH:/routes/orders/{order_id}/part-number
   */
  update_order_part_number = (
    { orderId }: { orderId: number },
    data: { part_number: string | null },
    params: RequestParams = {},
  ) =>
    this.request<{ id: number; part_number: string | null }, HTTPValidationError>({
      path: `/routes/orders/${orderId}/part-number`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description "Weiter bestellen": upload this order to the supplier's order-FTP interface (currently only TyreSystem)
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name reorder_from_supplier
   * @summary Reorder From Supplier
   * @request POST:/routes/orders/{order_id}/reorder
   */
  reorder_from_supplier = ({ orderId }: { orderId: number }, params: RequestParams = {}) =>
    this.request<ReorderOrderData, ReorderOrderError>({
      path: `/routes/orders/${orderId}/reorder`,
      method: "POST",
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Hard delete an order. Admins only.
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name delete_order
   * @summary Delete Order
   * @request DELETE:/routes/orders/{order_id}
   */
  delete_order = ({ orderId }: DeleteOrderParams, params: RequestParams = {}) =>
    this.request<DeleteOrderData, DeleteOrderError>({
      path: `/routes/orders/${orderId}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Create a manual order for a tire set (admin-only, for customers without email address).
   *
   * @tags dbtn/module:orders, dbtn/hasAuth
   * @name create_manual_order
   * @summary Create Manual Order
   * @request POST:/routes/orders/manual
   */
  create_manual_order = (data: ManualOrderRequest, params: RequestParams = {}) =>
    this.request<CreateManualOrderData, CreateManualOrderError>({
      path: `/routes/orders/manual`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:portal
   * @name resolve_portal
   * @summary Resolve Portal
   * @request POST:/routes/portal/resolve
   */
  resolve_portal = (data: PortalResolveRequest, params: RequestParams = {}) =>
    this.request<ResolvePortalData, ResolvePortalError>({
      path: `/routes/portal/resolve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:portal
   * @name list_offers
   * @summary List Offers
   * @request GET:/routes/portal/offers
   */
  list_offers = (query: ListOffersParams, params: RequestParams = {}) =>
    this.request<ListOffersData, ListOffersError>({
      path: `/routes/portal/offers`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * No description
   *
   * @tags dbtn/module:portal
   * @name create_order
   * @summary Create Order
   * @request POST:/routes/portal/order
   */
  create_order = (data: CreateOrderRequest, params: RequestParams = {}) =>
    this.request<CreateOrderData, CreateOrderError>({
      path: `/routes/portal/order`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Record that the customer wants to continue using the stored tires (no new purchase).
   *
   * @tags dbtn/module:portal
   * @name continue_use
   * @summary Continue Use
   * @request POST:/routes/portal/continue-use
   */
  continue_use = (data: ContinueUseRequest, params: RequestParams = {}) =>
    this.request<ContinueUseData, ContinueUseError>({
      path: `/routes/portal/continue-use`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description List orders for the portal customer, newest first. Includes both TIRE_PURCHASE and CONTINUE_USE.
   *
   * @tags dbtn/module:portal
   * @name my_orders
   * @summary My Orders
   * @request GET:/routes/portal/my-orders
   */
  my_orders = (query: MyOrdersParams, params: RequestParams = {}) =>
    this.request<MyOrdersData, MyOrdersError>({
      path: `/routes/portal/my-orders`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get public settings (no auth required) for portal display.
   *
   * @tags dbtn/module:portal
   * @name get_public_settings
   * @summary Get Public Settings
   * @request GET:/routes/portal/public-settings
   */
  get_public_settings = (query: { token?: string } = {}, params: RequestParams = {}) =>
    this.request<GetPublicSettingsData, HTTPValidationError>({
      path: `/routes/portal/public-settings`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List all portal tokens with metadata (admin only)
   *
   * @tags dbtn/module:portal, dbtn/hasAuth
   * @name list_portal_tokens
   * @summary List Portal Tokens
   * @request GET:/routes/portal/list-tokens
   */
  list_portal_tokens = (query: Record<string, never> = {}, params: RequestParams = {}) =>
    this.request<AdminTokenListItem[], HTTPValidationError>({
      path: `/routes/portal/list-tokens`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Revoke a portal token (admin only)
   *
   * @tags dbtn/module:portal, dbtn/hasAuth
   * @name revoke_portal_token
   * @summary Revoke Portal Token
   * @request DELETE:/routes/portal/revoke-token/{token}
   */
  revoke_portal_token = (data: { token: string }, params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/portal/revoke-token/${data.token}`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Revoke multiple portal tokens (admin only)
   *
   * @tags dbtn/module:portal, dbtn/hasAuth
   * @name batch_revoke_portal_tokens
   * @summary Batch Revoke Portal Tokens
   * @request POST:/routes/portal/batch-revoke-tokens
   */
  batch_revoke_portal_tokens = (data: BatchRevokeTokensRequest, params: RequestParams = {}) =>
    this.request<{ success: boolean; message: string; updated_count: number }, HTTPValidationError>({
      path: `/routes/portal/batch-revoke-tokens`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete all revoked portal tokens (admin only)
   *
   * @tags dbtn/module:portal, dbtn/hasAuth
   * @name cleanup_revoked_portal_tokens
   * @summary Cleanup Revoked Portal Tokens
   * @request DELETE:/routes/portal/cleanup-revoked-tokens
   */
  cleanup_revoked_portal_tokens = (params: RequestParams = {}) =>
    this.request<CleanupRevokedTokensResponse, HTTPValidationError>({
      path: `/routes/portal/cleanup-revoked-tokens`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get portal text strings (public endpoint)
   *
   * @tags dbtn/module:portal_texts
   * @name get_portal_texts
   * @summary Get Portal Texts
   * @request GET:/routes/portal_texts
   */
  get_portal_texts = (query: { token?: string } = {}, params: RequestParams = {}) =>
    this.request<GetPortalTextsData, GetPortalTextsError>({
      path: `/routes/portal_texts`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get portal text strings (admin only, for editing)
   *
   * @tags dbtn/module:portal_texts, dbtn/hasAuth
   * @name get_portal_texts_admin
   * @summary Get Portal Texts Admin
   * @request GET:/routes/portal_texts/admin
   */
  get_portal_texts_admin = (params: RequestParams = {}) =>
    this.request<GetPortalTextsAdminData, GetPortalTextsAdminError>({
      path: `/routes/portal_texts/admin`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update portal text strings (admin only)
   *
   * @tags dbtn/module:portal_texts, dbtn/hasAuth
   * @name update_portal_texts_admin
   * @summary Update Portal Texts Admin
   * @request PUT:/routes/portal_texts/admin
   */
  update_portal_texts_admin = (data: PortalTextsUpdateRequest, params: RequestParams = {}) =>
    this.request<UpdatePortalTextsAdminData, UpdatePortalTextsAdminError>({
      path: `/routes/portal_texts/admin`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
  * @description Update current user's name
  *
  * @tags dbtn/module:users, dbtn/hasAuth
  * @name update_user_name
  * @summary Update User Name
  * @request PUT:/routes/users/me/name
  */
  update_user_name = (data: { name: string }, params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/users/me/name`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
  * @description Update current user's password
  *
  * @tags dbtn/module:users, dbtn/hasAuth
   * @name update_user_password
  * @summary Update User Password
  * @request PUT:/routes/users/me/password
  */
  update_user_password = (
    data: { current_password: string; new_password: string },
    params: RequestParams = {},
  ) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/users/me/password`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  // ========================================
  // Add these methods to your Brain class in Brain.ts
  // ========================================

  /**
   * @description List all tire sets with optional filtering
   *
   * @tags dbtn/module:tire_sets, dbtn/hasAuth
   * @name list_tire_sets
   * @summary List Tire Sets
   * @request GET:/tire-sets
   */
  list_tire_sets = (query: ListTireSetsParams, params: RequestParams = {}) =>
    this.request<ListTireSetsData, ListTireSetsError>({
      path: `/tire-sets`,
      method: "GET",
      query: query,
      ...params,
    });

  get_tire_set = ({ tireSetId }: { tireSetId: number }, params: RequestParams = {}) =>
    this.request<import("./data-contracts").TireSetListItem, HTTPValidationError>({
      path: `/tire-sets/${tireSetId}`,
      method: "GET",
      ...params,
    });

  get_tire_health_thresholds = (params: RequestParams = {}) =>
    this.request<import("./data-contracts").TireHealthThresholds, HTTPValidationError>({
      path: `/tire-sets/thresholds`,
      method: "GET",
      ...params,
    });

  /**
   * @description List audit log entries with filtering and pagination. Admin access required.
   *
   * @tags dbtn/module:audit, dbtn/hasAuth
   * @name list_audit_logs
   * @summary List Audit Logs
   * @request GET:/audit/logs
   */
  list_audit_logs = (query: ListAuditLogsParams, params: RequestParams = {}) =>
    this.request<AuditLogEntry[], HTTPValidationError>({
      path: `/routes/audit/logs`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get audit log statistics. Admin access required.
   *
   * @tags dbtn/module:audit, dbtn/hasAuth
   * @name get_audit_stats
   * @summary Get Audit Stats
   * @request GET:/audit/stats
   */
  get_audit_stats = (query: GetAuditStatsParams, params: RequestParams = {}) =>
    this.request<AuditLogStats, HTTPValidationError>({
      path: `/routes/audit/stats`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description List error log entries with filtering and pagination. Admin access required.
   *
   * @tags dbtn/module:errors, dbtn/hasAuth
   * @name list_error_logs
   * @summary List Error Logs
   * @request GET:/errors/logs
   */
  list_error_logs = (query: ListErrorLogsParams, params: RequestParams = {}) =>
    this.request<ErrorLogEntry[], HTTPValidationError>({
      path: `/routes/errors/logs`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Get error log statistics. Admin access required.
   *
   * @tags dbtn/module:errors, dbtn/hasAuth
   * @name get_error_stats
   * @summary Get Error Stats
   * @request GET:/errors/stats
   */
  get_error_stats = (query: GetErrorStatsParams, params: RequestParams = {}) =>
    this.request<ErrorLogStats, HTTPValidationError>({
      path: `/routes/errors/stats`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Mark an error as resolved. Admin access required.
   *
   * @tags dbtn/module:errors, dbtn/hasAuth
   * @name resolve_error
   * @summary Resolve Error
   * @request PATCH:/errors/{error_id}/resolve
   */
  resolve_error = (errorId: number, data: ResolveErrorRequest, params: RequestParams = {}) =>
    this.request<{ success: boolean; message: string }, HTTPValidationError>({
      path: `/routes/errors/${errorId}/resolve`,
      method: "PATCH",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Mark multiple errors as resolved
   *
   * @tags dbtn/module:errors, dbtn/hasAuth
   * @name batch_resolve_errors
   * @summary Batch Resolve Errors
   * @request POST:/errors/batch-resolve
   */
  batch_resolve_errors = (data: BatchResolveRequest, params: RequestParams = {}) =>
    this.request<{ success: boolean; message: string; updated_count: number }, HTTPValidationError>({
      path: `/routes/errors/batch-resolve`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Delete all resolved errors
   *
   * @tags dbtn/module:errors, dbtn/hasAuth
   * @name cleanup_resolved_errors
   * @summary Cleanup Resolved Errors
   * @request DELETE:/errors/cleanup-resolved
   */
  cleanup_resolved_errors = (params: RequestParams = {}) =>
    this.request<CleanupResolvedResponse, HTTPValidationError>({
      path: `/routes/errors/cleanup-resolved`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Get 2FA/TOTP status for current user
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name get_2fa_status
   * @summary Get 2FA Status
   * @request GET:/routes/auth/2fa/status
   */
  get_2fa_status = (params: RequestParams = {}) =>
    this.request<TOTPStatusResponse, HTTPValidationError>({
      path: `/routes/auth/2fa/status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Setup 2FA/TOTP for current user
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name setup_2fa
   * @summary Setup 2FA
   * @request POST:/routes/auth/2fa/setup
   */
  setup_2fa = (params: RequestParams = {}) =>
    this.request<TOTPSetupResponse, HTTPValidationError>({
      path: `/routes/auth/2fa/setup`,
      method: "POST",
      ...params,
    });

  /**
   * @description Verify TOTP code and enable 2FA
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name verify_2fa
   * @summary Verify 2FA Code
   * @request POST:/routes/auth/2fa/verify
   */
  verify_2fa = (code: string, params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/auth/2fa/verify`,
      method: "POST",
      body: { code },
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Disable 2FA for current user
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name disable_2fa
   * @summary Disable 2FA
   * @request DELETE:/routes/auth/2fa/disable
   */
  disable_2fa = (params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/auth/2fa/disable`,
      method: "DELETE",
      ...params,
    });

  /**
   * @description Regenerate backup codes
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name regenerate_backup_codes
   * @summary Regenerate Backup Codes
   * @request POST:/routes/auth/2fa/backup-codes/regenerate
   */
  regenerate_backup_codes = (params: RequestParams = {}) =>
    this.request<BackupCodesResponse, HTTPValidationError>({
      path: `/routes/auth/2fa/backup-codes/regenerate`,
      method: "POST",
      ...params,
    });

  /**
   * @description List all active sessions for current user
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name list_active_sessions
   * @summary List Active Sessions
   * @request GET:/routes/auth/sessions
   */
  list_active_sessions = (params: RequestParams = {}) =>
    this.request<SessionListItem[], HTTPValidationError>({
      path: `/routes/auth/sessions`,
      method: "GET",
      ...params,
    });

  /**
   * @description Revoke a specific session
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name revoke_session
   * @summary Revoke Session
   * @request POST:/routes/auth/sessions/revoke
   */
  revoke_session = (sessionId: string, params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/auth/sessions/revoke`,
      method: "POST",
      body: { session_id: sessionId },
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Logout from all sessions
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name logout_all_sessions
   * @summary Logout All Sessions
   * @request POST:/routes/auth/logout
   */
  logout_all_sessions = (params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/auth/logout`,
      method: "POST",
      body: { revoke_all: true },
      type: ContentType.Json,
      ...params,
    });

  /**
   * Revoke all sessions except the current one — unlike logout_all_sessions,
   * this does NOT clear the caller's own cookie (see backend endpoint
   * docstring / Memory project_session_system_alignment).
   *
   * @tags dbtn/module:auth, dbtn/hasAuth
   * @name revoke_other_sessions
   * @summary Revoke Other Sessions
   * @request POST:/routes/auth/sessions/revoke-others
   */
  revoke_other_sessions = (params: RequestParams = {}) =>
    this.request<{ message: string }, HTTPValidationError>({
      path: `/routes/auth/sessions/revoke-others`,
      method: "POST",
      ...params,
    });

  /**
   * Search vehicle by license plate for tire change page
   *
   * @request GET:/routes/tire-change/search/{license_plate}
   */
  search_tire_change_by_license = (licensePlate: string, params: RequestParams = {}) =>
    this.request<SearchTireChangeByLicenseData, SearchTireChangeByLicenseError>({
      path: `/routes/tire-change/search/${licensePlate}`,
      method: "GET",
      format: "json",
      ...params,
    });

  /**
   * Get tire change preparation PDF
   *
   * @request GET:/routes/tire-change/preparation-pdf/{vehicle_id}
   */
  get_preparation_pdf = (vehicleId: number, params: RequestParams = {}) =>
    this.request<GetPreparationPdfData, GetPreparationPdfError>({
      path: `/routes/tire-change/preparation-pdf/${vehicleId}`,
      method: "GET",
      format: "blob",
      ...params,
    });

  /**
   * Get tire labels PDF
   *
   * @request GET:/routes/tire-change/tire-labels-pdf/{tire_set_id}
   */
  get_tire_labels_pdf = (tireSetId: number, params: RequestParams = {}) =>
    this.request<GetTireLabelsPdfData, GetTireLabelsPdfError>({
      path: `/routes/tire-change/tire-labels-pdf/${tireSetId}`,
      method: "GET",
      format: "blob",
      ...params,
    });

  get_label_calibration_pdf = (params: RequestParams = {}) =>
    this.request<Blob, void>({
      path: `/routes/tire-change/tire-labels-pdf/calibration`,
      method: "GET",
      format: "blob",
      ...params,
    });

  /**
   * Mark a stored tire set as retrieved by the customer
   *
   * @request POST:/routes/tire-change/retrieve/{tire_set_id}
   */
  retrieve_tire_set = (
    tireSetId: number,
    data?: { customer_signature_b64?: string; employee_signature_b64?: string },
    params: RequestParams = {},
  ) =>
    this.request<File, HTTPValidationError>({
      path: `/routes/tire-change/retrieve/${tireSetId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "blob",
      ...params,
    });

  /**
   * Get archived signed retrieval receipt PDF
   *
   * @request GET:/routes/tire-change/retrieval-pdf/{tire_set_id}
   */
  get_archived_retrieval_pdf = (tireSetId: number, params: RequestParams = {}) =>
    this.request<File, HTTPValidationError>({
      path: `/routes/tire-change/retrieval-pdf/${tireSetId}`,
      method: "GET",
      format: "blob",
      ...params,
    });

  /**
   * Re-store a retrieved tire set (marks it as stored again, optionally assigns location)
   *
   * @request POST:/routes/tire-change/re-store/{tire_set_id}
   */
  re_store_tire_set = (
    tireSetId: number,
    data: ReStoreRequest,
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; message: string }, HTTPValidationError>({
      path: `/routes/tire-change/re-store/${tireSetId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * Send retrieval receipt PDF to customer via email
   *
   * @request POST:/routes/tire-change/send-retrieval-email/{tire_set_id}
   */
  send_retrieval_email = (
    tireSetId: number,
    data: SendRetrievalEmailRequest,
    params: RequestParams = {},
  ) =>
    this.request<{ success: boolean; message: string }, HTTPValidationError>({
      path: `/routes/tire-change/send-retrieval-email/${tireSetId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * Get storage locations for a tenant
   *
   * @request GET:/routes/storage-locations/
   */
  get_storage_locations = (tenantId: number, activeOnly: boolean = false, params: RequestParams = {}) =>
    this.request<GetStorageLocationsData, GetStorageLocationsError>({
      path: `/routes/storage-locations/`,
      method: "GET",
      query: { tenant_id: tenantId, active_only: activeOnly },
      format: "json",
      ...params,
    });

  /**
   * Update storage location
   *
   * @request PUT:/routes/storage-locations/{location_id}
   */
  update_storage_location = (locationId: number, data: StorageLocationUpdate, params: RequestParams = {}) =>
    this.request<StorageLocationResponse, HTTPValidationError>({
      path: `/routes/storage-locations/${locationId}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * Delete storage location
   *
   * @request DELETE:/routes/storage-locations/{location_id}
   */
  delete_storage_location = (locationId: number, params: RequestParams = {}) =>
    this.request<void, HTTPValidationError>({
      path: `/routes/storage-locations/${locationId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });

  /**
   * Synchronize all GettyGo tire prices manually
   *
   * @request POST:/routes/gettygo/sync-all
   */
  syncAllGettyGoPrices = (params: RequestParams = {}) =>
    this.request<GettyGoSyncAllResponse, HTTPValidationError>({
      path: `/routes/gettygo/sync-all`,
      method: "POST",
      type: ContentType.Json,
      ...params,
    });

  /**
   * No description
   *
   * @name SyncAllTyreSystemPrices
   * @request POST:/routes/tyresystem/sync-all
   */
  syncAllTyreSystemPrices = (params: RequestParams = {}) =>
    this.request<TyreSystemSyncResponse, HTTPValidationError>({
      path: `/routes/tyresystem/sync-all`,
      method: "POST",
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Get whether the TyreSystem order interface is enabled (no FTP details)
   *
   * @tags dbtn/module:tyresystem, dbtn/hasAuth
   * @name get_tyresystem_order_interface_status
   * @summary Get Tyresystem Order Interface Status
   * @request GET:/routes/tyresystem/order-settings/status
   */
  get_tyresystem_order_interface_status = (params: RequestParams = {}) =>
    this.request<GetTyresystemOrderInterfaceStatusData, HTTPValidationError>({
      path: `/routes/tyresystem/order-settings/status`,
      method: "GET",
      ...params,
    });

  /**
   * @description Get the tenant's TyreSystem order-interface FTP settings (password never returned)
   *
   * @tags dbtn/module:tyresystem, dbtn/hasAuth
   * @name get_tyresystem_order_settings
   * @summary Get Tyresystem Order Settings
   * @request GET:/routes/tyresystem/order-settings
   */
  get_tyresystem_order_settings = (params: RequestParams = {}) =>
    this.request<GetTyresystemOrderSettingsData, HTTPValidationError>({
      path: `/routes/tyresystem/order-settings`,
      method: "GET",
      ...params,
    });

  /**
   * @description Update the tenant's TyreSystem order-interface FTP settings (own account, see Schnittstellenbeschreibung Schritt 2)
   *
   * @tags dbtn/module:tyresystem, dbtn/hasAuth
   * @name update_tyresystem_order_settings
   * @summary Update Tyresystem Order Settings
   * @request PUT:/routes/tyresystem/order-settings
   */
  update_tyresystem_order_settings = (data: OrderSettingsUpdateRequest, params: RequestParams = {}) =>
    this.request<UpdateTyresystemOrderSettingsData, UpdateTyresystemOrderSettingsError>({
      path: `/routes/tyresystem/order-settings`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /** GET /routes/employees */
  list_employees = (params: RequestParams = {}) =>
    this.request<ListEmployeesData, void>({
      path: `/routes/employees`,
      method: "GET",
      format: "json",
      ...params,
    });

  /** POST /routes/employees */
  create_employee = (data: EmployeeCreateRequest, params: RequestParams = {}) =>
    this.request<CreateEmployeeData, CreateEmployeeError>({
      path: `/routes/employees`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /** DELETE /routes/employees/{employee_id} */
  delete_employee = (employeeId: number, params: RequestParams = {}) =>
    this.request<DeleteEmployeeData, DeleteEmployeeError>({
      path: `/routes/employees/${employeeId}`,
      method: "DELETE",
      ...params,
    });

  /** POST /routes/tire-change/complete-swap/{vehicle_id} */
  complete_swap = (vehicleId: number, data: CompleteSwapRequest, params: RequestParams = {}) =>
    this.request<CompleteSwapData, CompleteSwapError>({
      path: `/routes/tire-change/complete-swap/${vehicleId}`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /** GET /routes/tire-change/print-queue */
  get_print_queue = (params: RequestParams = {}) =>
    this.request<GetPrintQueueData, void>({
      path: `/routes/tire-change/print-queue`,
      method: "GET",
      format: "json",
      ...params,
    });

  /** POST /routes/tire-change/mark-printed/{tire_set_id} */
  mark_printed = (tireSetId: number, params: RequestParams = {}) =>
    this.request<MarkPrintedData, MarkPrintedError>({
      path: `/routes/tire-change/mark-printed/${tireSetId}`,
      method: "POST",
      format: "json",
      ...params,
    });

  /** GET /routes/tire-change/download-swap-receipt/{tire_set_id} */
  download_swap_receipt = (tireSetId: number, params: RequestParams = {}) =>
    this.request<DownloadSwapReceiptData, DownloadSwapReceiptError>({
      path: `/routes/tire-change/download-swap-receipt/${tireSetId}`,
      method: "GET",
      format: "blob",
      ...params,
    });
  /**
   * @description Portal: Änderungswunsch für Stammdaten stellen (Werkstatt bestätigt)
   *
   * @tags dbtn/module:portal
   * @name create_change_request
   * @request POST:/routes/portal/change-request
   */
  create_change_request = (data: PortalChangeRequestCreate, params: RequestParams = {}) =>
    this.request<CreateChangeRequestData, CreateChangeRequestError>({
      path: `/routes/portal/change-request`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal: aktueller bzw. letzter Änderungswunsch (null = keiner)
   *
   * @tags dbtn/module:portal
   * @name get_change_request_status
   * @request POST:/routes/portal/change-request/status
   */
  get_change_request_status = (data: PortalChangeRequestAccess, params: RequestParams = {}) =>
    this.request<GetChangeRequestStatusData, GetChangeRequestStatusError>({
      path: `/routes/portal/change-request/status`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal: offenen Änderungswunsch zurückziehen
   *
   * @tags dbtn/module:portal
   * @name withdraw_change_request
   * @request POST:/routes/portal/change-request/withdraw
   */
  withdraw_change_request = (data: PortalChangeRequestAccess, params: RequestParams = {}) =>
    this.request<WithdrawChangeRequestData, WithdrawChangeRequestError>({
      path: `/routes/portal/change-request/withdraw`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Werkstatt: Änderungswünsche der Kunden auflisten
   *
   * @tags dbtn/module:customer_change_requests, dbtn/hasAuth
   * @name list_customer_change_requests
   * @request GET:/routes/customer-change-requests
   */
  list_customer_change_requests = (query: ListCustomerChangeRequestsParams = {}, params: RequestParams = {}) =>
    this.request<ListCustomerChangeRequestsData, ListCustomerChangeRequestsError>({
      path: `/routes/customer-change-requests`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Werkstatt: Anzahl offener Änderungswünsche (Badge)
   *
   * @tags dbtn/module:customer_change_requests, dbtn/hasAuth
   * @name count_pending_customer_change_requests
   * @request GET:/routes/customer-change-requests/pending-count
   */
  count_pending_customer_change_requests = (params: RequestParams = {}) =>
    this.request<CountPendingCustomerChangeRequestsData, CountPendingCustomerChangeRequestsError>({
      path: `/routes/customer-change-requests/pending-count`,
      method: "GET",
      ...params,
    });

  /**
   * @description Werkstatt: Änderungswunsch annehmen (übernimmt die Werte in den Kunden)
   *
   * @tags dbtn/module:customer_change_requests, dbtn/hasAuth
   * @name approve_customer_change_request
   * @request POST:/routes/customer-change-requests/{request_id}/approve
   */
  approve_customer_change_request = ({ requestId }: ChangeRequestIdParams, params: RequestParams = {}) =>
    this.request<ApproveCustomerChangeRequestData, ApproveCustomerChangeRequestError>({
      path: `/routes/customer-change-requests/${requestId}/approve`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: Änderungswunsch ablehnen (optional mit Begründung)
   *
   * @tags dbtn/module:customer_change_requests, dbtn/hasAuth
   * @name reject_customer_change_request
   * @request POST:/routes/customer-change-requests/{request_id}/reject
   */
  reject_customer_change_request = (
    { requestId }: ChangeRequestIdParams,
    data: RejectCustomerChangeRequestBody,
    params: RequestParams = {},
  ) =>
    this.request<RejectCustomerChangeRequestData, RejectCustomerChangeRequestError>({
      path: `/routes/customer-change-requests/${requestId}/reject`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Portal-Account: Name/Logo/Markenfarbe der Werkstatt zu einem Kürzel (Login-Seite)
   *
   * @tags dbtn/module:customer_account
   * @name get_account_workshop
   * @request GET:/routes/portal/account/workshop
   */
  get_account_workshop = (query: GetAccountWorkshopParams, params: RequestParams = {}) =>
    this.request<GetAccountWorkshopData, GetAccountWorkshopError>({
      path: `/routes/portal/account/workshop`,
      method: "GET",
      query: query,
      ...params,
    });

  /**
   * @description Portal-Account: festen Zugang einrichten (Bestätigungsmail an die hinterlegte Adresse)
   *
   * @tags dbtn/module:customer_account
   * @name account_start
   * @request POST:/routes/portal/account/start
   */
  account_start = (data: AccountStartRequest, params: RequestParams = {}) =>
    this.request<AccountStartData, AccountStartError>({
      path: `/routes/portal/account/start`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal-Account: Passwort festlegen und anmelden (Link aus der Bestätigungsmail)
   *
   * @tags dbtn/module:customer_account
   * @name account_activate
   * @request POST:/routes/portal/account/activate
   */
  account_activate = (data: AccountActivateRequest, params: RequestParams = {}) =>
    this.request<AccountActivateData, AccountActivateError>({
      path: `/routes/portal/account/activate`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal-Account: Anmeldung mit E-Mail und Passwort
   *
   * @tags dbtn/module:customer_account
   * @name account_login
   * @request POST:/routes/portal/account/login
   */
  account_login = (data: AccountLoginRequest, params: RequestParams = {}) =>
    this.request<AccountLoginData, AccountLoginError>({
      path: `/routes/portal/account/login`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal-Account: Abmelden (beendet die Sitzung)
   *
   * @tags dbtn/module:customer_account
   * @name account_logout
   * @request POST:/routes/portal/account/logout
   */
  account_logout = (params: RequestParams = {}) =>
    this.request<AccountLogoutData, AccountLogoutError>({
      path: `/routes/portal/account/logout`,
      method: "POST",
      ...params,
    });

  /**
   * @description Portal-Account: Kunde, Werkstatt und Fahrzeuge der angemeldeten Sitzung
   *
   * @tags dbtn/module:customer_account
   * @name get_account_me
   * @request GET:/routes/portal/account/me
   */
  get_account_me = (params: RequestParams = {}) =>
    this.request<GetAccountMeData, GetAccountMeError>({
      path: `/routes/portal/account/me`,
      method: "GET",
      ...params,
    });

  /**
   * @description Portal-Account: Passwort vergessen (antwortet immer gleich)
   *
   * @tags dbtn/module:customer_account
   * @name account_forgot
   * @request POST:/routes/portal/account/forgot
   */
  account_forgot = (data: AccountForgotRequest, params: RequestParams = {}) =>
    this.request<AccountForgotData, AccountForgotError>({
      path: `/routes/portal/account/forgot`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal-Account: neues Passwort per Link aus der E-Mail setzen
   *
   * @tags dbtn/module:customer_account
   * @name account_reset
   * @request POST:/routes/portal/account/reset
   */
  account_reset = (data: AccountResetRequest, params: RequestParams = {}) =>
    this.request<AccountResetData, AccountResetError>({
      path: `/routes/portal/account/reset`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal-Account: Passwort ändern (angemeldet), beendet die anderen Sitzungen
   *
   * @tags dbtn/module:customer_account
   * @name account_change_password
   * @request POST:/routes/portal/account/password
   */
  account_change_password = (data: AccountPasswordChangeRequest, params: RequestParams = {}) =>
    this.request<AccountChangePasswordData, AccountChangePasswordError>({
      path: `/routes/portal/account/password`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Werkstatt: Status des festen Portal-Zugangs eines Kunden (null = kein Zugang)
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name get_customer_account
   * @request GET:/routes/customer-accounts/by-customer/{customer_id}
   */
  get_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<GetCustomerAccountData, GetCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}`,
      method: "GET",
      ...params,
    });

  /**
   * @description Werkstatt: Zugang sperren (beendet Sitzungen, entwertet offene Links)
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name disable_customer_account
   * @request POST:/routes/customer-accounts/by-customer/{customer_id}/disable
   */
  disable_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<DisableCustomerAccountData, DisableCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}/disable`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: alle Portal-Zugänge des Mandanten
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name list_customer_accounts
   * @request GET:/routes/customer-accounts
   */
  list_customer_accounts = (params: RequestParams = {}) =>
    this.request<ListCustomerAccountsData, ListCustomerAccountsError>({
      path: `/routes/customer-accounts`,
      method: "GET",
      ...params,
    });

  /**
   * @description Werkstatt: wartenden Zugang freigeben (Token-Links des Kunden werden widerrufen)
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name approve_customer_account
   * @request POST:/routes/customer-accounts/by-customer/{customer_id}/approve
   */
  approve_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<ApproveCustomerAccountData, ApproveCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}/approve`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: gesperrten Zugang entsperren
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name enable_customer_account
   * @request POST:/routes/customer-accounts/by-customer/{customer_id}/enable
   */
  enable_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<EnableCustomerAccountData, EnableCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}/enable`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: vorübergehende Sperre nach Fehlversuchen aufheben
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name unlock_customer_account
   * @request POST:/routes/customer-accounts/by-customer/{customer_id}/unlock
   */
  unlock_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<UnlockCustomerAccountData, UnlockCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}/unlock`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: Aktivierungslink erneut senden
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name resend_customer_account_activation
   * @request POST:/routes/customer-accounts/by-customer/{customer_id}/resend-activation
   */
  resend_customer_account_activation = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<ResendCustomerAccountActivationData, ResendCustomerAccountActivationError>({
      path: `/routes/customer-accounts/by-customer/${customerId}/resend-activation`,
      method: "POST",
      ...params,
    });

  /**
   * @description Werkstatt: festen Zugang löschen (Kunde kann ihn neu einrichten)
   *
   * @tags dbtn/module:customer_account_admin, dbtn/hasAuth
   * @name delete_customer_account
   * @request DELETE:/routes/customer-accounts/by-customer/{customer_id}
   */
  delete_customer_account = ({ customerId }: CustomerAccountParams, params: RequestParams = {}) =>
    this.request<DeleteCustomerAccountData, DeleteCustomerAccountError>({
      path: `/routes/customer-accounts/by-customer/${customerId}`,
      method: "DELETE",
      format: "json",
      ...params,
    });

  /**
   * @description Portal: Protokolle (Quittungen als PDF) des Fahrzeugs
   *
   * @tags dbtn/module:portal
   * @name list_protocols
   * @request POST:/routes/portal/protocols
   */
  list_protocols = (data: PortalProtocolsRequest, params: RequestParams = {}) =>
    this.request<ListProtocolsData, ListProtocolsError>({
      path: `/routes/portal/protocols`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Portal: Buchungsfenster je Saison (offen/geschlossen mit Hinweistext)
   *
   * @tags dbtn/module:portal
   * @name get_portal_booking_window
   * @request POST:/routes/portal/booking-window
   */
  get_portal_booking_window = (data: PortalProtocolsRequest, params: RequestParams = {}) =>
    this.request<GetPortalBookingWindowData, GetPortalBookingWindowError>({
      path: `/routes/portal/booking-window`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Werkstatt (Admin): Einstellungen der Buchungsfenster
   *
   * @tags dbtn/module:booking_window, dbtn/hasAuth
   * @name get_booking_window_settings
   * @request GET:/routes/booking-window
   */
  get_booking_window_settings = (params: RequestParams = {}) =>
    this.request<GetBookingWindowSettingsData, GetBookingWindowSettingsError>({
      path: `/routes/booking-window`,
      method: "GET",
      ...params,
    });

  /**
   * @description Werkstatt (Admin): Farbe der Werkstatt für Kundenportal und Kundenmails lesen
   *
   * @tags dbtn/module:portal_brand, dbtn/hasAuth
   * @name get_portal_brand
   * @request GET:/routes/portal-brand
   */
  get_portal_brand = (params: RequestParams = {}) =>
    this.request<GetPortalBrandData, GetPortalBrandError>({
      path: `/routes/portal-brand`,
      method: "GET",
      ...params,
    });

  /**
   * @description Werkstatt (Admin): Farbe der Werkstatt speichern (#RRGGBB) oder mit null zurücksetzen
   *
   * @tags dbtn/module:portal_brand, dbtn/hasAuth
   * @name update_portal_brand
   * @request PUT:/routes/portal-brand
   */
  update_portal_brand = (data: PortalBrandUpdate, params: RequestParams = {}) =>
    this.request<UpdatePortalBrandData, UpdatePortalBrandError>({
      path: `/routes/portal-brand`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Werkstatt (Admin): Einstellungen der Buchungsfenster speichern
   *
   * @tags dbtn/module:booking_window, dbtn/hasAuth
   * @name update_booking_window_settings
   * @request PUT:/routes/booking-window
   */
  update_booking_window_settings = (data: BookingWindowSettings, params: RequestParams = {}) =>
    this.request<UpdateBookingWindowSettingsData, UpdateBookingWindowSettingsError>({
      path: `/routes/booking-window`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Portal: kurzlebiges Ticket (60 s) zum Öffnen eines Protokoll-PDFs holen; die Zugangsdaten
   * stehen im Body, nie in der Adresse des PDFs
   *
   * @tags dbtn/module:portal
   * @name create_protocol_ticket
   * @request POST:/routes/portal/protocols/{kind}/{tire_set_id}/ticket
   */
  create_protocol_ticket = (
    { kind, tireSetId }: CreateProtocolTicketParams,
    data: PortalProtocolsRequest,
    params: RequestParams = {},
  ) =>
    this.request<CreateProtocolTicketData, CreateProtocolTicketError>({
      path: `/routes/portal/protocols/${kind}/${tireSetId}/ticket`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      ...params,
    });
}